import { t } from 'i18next';
import { TabSegment } from '../../components/tab/TabSegment';

interface TradingCategoryTabProps {
  activeTab: number;
  onTabChange?: (tab: number) => void;
}

const TradingCategoryTab = ({ activeTab, onTabChange }: TradingCategoryTabProps) => {
  const handleTabClick = (tab: number) => {
    onTabChange?.(tab);
  };

  return (
    <div className="w-full h-[44px] mx-auto">
      <TabSegment
        tabIndex={activeTab}
        segments={[t('NewTradingPhotoCards.tabSale'), t('NewTradingPhotoCards.tabExchange')]}
        onTabChange={handleTabClick}
      />
    </div>
  );
};

export default TradingCategoryTab;
